import React, { useState } from "react";
import "./App.css";
import Contact from "./contact";

const allImages = [
  "/sign-up.png",
  "/checkout.png",
  "/barricade-2.png",
  "/aftermarket-nz.png",
  "https://lh3.googleusercontent.com/y9n9az0bnKrcmSQ0RQCMOduqaLgUhqMASs9Jk0_9OcpGXQ5GYTTIOAzbNmX3R4oK4g",
  "/plush.png",
];

function App() {
  const [lightboxIndex, setLightboxIndex] = useState<number | null>(null);

  return (
    <div className="bg-gray-100 h-lvh">
      {lightboxIndex !== null && (
        <div
          className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50"
          onClick={() => setLightboxIndex(null)}
        >
          <button
            className="absolute left-4 text-white text-5xl font-thin select-none px-4 py-2"
            onClick={(e) => {
              e.stopPropagation();
              setLightboxIndex(
                (lightboxIndex - 1 + allImages.length) % allImages.length,
              );
            }}
          >
            &#8249;
          </button>
          <img
            src={allImages[lightboxIndex]}
            className="max-h-screen max-w-screen-lg object-contain p-4"
            alt="enlarged"
          />
          <button
            className="absolute right-4 text-white text-5xl font-thin select-none px-4 py-2"
            onClick={(e) => {
              e.stopPropagation();
              setLightboxIndex((lightboxIndex + 1) % allImages.length);
            }}
          >
            &#8250;
          </button>
        </div>
      )}
      <div className="text-center md:mt-32 mt-16">
        <h6 className="font-medium text-gray-600 text-lg md:text-2xl uppercase mb-8">
          Eric Chow
        </h6>

        <h1 className="font-normal text-gray-900 text-4xl md:text-6xl leading-none mb-16">
          Software Engineer
        </h1>

        <hr className="h-px my-8 w-7/12  border-0 bg-gray-400 mx-auto"></hr>
        <h1
          id="projects"
          className="mt-12 font-normal text-gray-900 text-2xl md:text-3xl leading-none mb-8"
        >
          Projects
        </h1>
      </div>

      <br></br>

      <div className="container max-w-screen-xl mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <div className="bg-gray-50 px-8 py-10 rounded-md">
            <a href="https://app.business.booking.com">
              <h4 className="font-medium text-gray-700 text-lg mb-4">
                Booking.com for Business
              </h4>
            </a>
            <p className="font-normal text-gray-500 text-md">
              Worked on creating various pages in the Booking.com for Business
              website, a travel management platform for companies.
            </p>
            <div className="flex flex-col gap-2 mt-4">
              <img
                src="/sign-up.png"
                alt="Sign-up page"
                className="w-full object-cover rounded cursor-pointer"
                style={{ maxHeight: 250 }}
                onClick={() => setLightboxIndex(0)}
              ></img>
              <img
                src="/checkout.png"
                alt="Checkout page"
                className="w-full object-cover rounded cursor-pointer"
                style={{ maxHeight: 250 }}
                onClick={() => setLightboxIndex(1)}
              ></img>
            </div>
          </div>

          <div className="bg-gray-50 px-8 py-10 rounded-md">
            <a href="https://barricade.gg">
              <h4 className="font-medium text-gray-700 text-lg mb-4">
                Barricade
              </h4>
            </a>
            <p className="font-normal text-gray-500 text-md">
              Simple 1v1 browser-based board{" "}
              <a
                className="text-blue-500 underline"
                href="https://barricade.gg"
              >
                game
              </a>
              , also available on{" "}
              <a
                className="text-blue-500 underline"
                href="https://play.google.com/store/apps/details?id=com.quoridor.gg.Quoridor"
              >
                Android
              </a>{" "}
              and{" "}
              <a
                className="text-blue-500 underline"
                href="https://apps.apple.com/us/app/quoridor-gg/id1633764827"
              >
                iOS
              </a>
              . Features an online mode and vs computer mode.
            </p>
            <img
              src="/barricade-2.png"
              alt="Barricade game"
              className="flex justify-center items-center mt-4 m-auto cursor-pointer"
              style={{ maxHeight: 250 }}
              onClick={() => setLightboxIndex(2)}
            ></img>{" "}
          </div>

          <div className="bg-gray-50 px-8 py-10 rounded-md">
            <a href="https://aftermarket.nz">
              <h4 className="font-medium text-gray-700 text-lg mb-4">
                aftermarket.nz
              </h4>
            </a>

            <p className="font-normal text-gray-500 text-md">
              Marketplace for selling .co.nz and .nz domain names
            </p>
            <img
              alt="aftermarket.nz"
              className="flex justify-center items-center mt-4 m-auto cursor-pointer"
              src="/aftermarket-nz.png"
              style={{ maxHeight: 250 }}
              onClick={() => setLightboxIndex(3)}
            ></img>
          </div>

          <div className="bg-gray-50 px-8 py-10 rounded-md">
            <a href="https://perfectpitch.io">
              <h4 className="font-medium text-gray-700 text-lg mb-4">
                perfectpitch.io
              </h4>
            </a>

            <p className="font-normal text-gray-500 text-md">
              <a
                className="text-blue-500 underline"
                href="https://play.google.com/store/apps/details?id=com.labgg.perfectpitchtrainer"
              >
                Android app
              </a>{" "}
              and{" "}
              <a
                className="text-blue-500 underline"
                href="https://perfectpitch.io/trainer"
              >
                website
              </a>{" "}
              for training the ability to recognise musical notes by ear. Built
              using Android studio
            </p>
            <img
              src="https://lh3.googleusercontent.com/y9n9az0bnKrcmSQ0RQCMOduqaLgUhqMASs9Jk0_9OcpGXQ5GYTTIOAzbNmX3R4oK4g"
              alt="perfectpitch.io app"
              className="flex justify-center items-center mt-4 m-auto cursor-pointer"
              style={{ maxHeight: 250 }}
              onClick={() => setLightboxIndex(4)}
            ></img>
          </div>

          <div className="bg-gray-50 px-8 py-10 rounded-md">
            <a href="https://plu.sh">
              <h4 className="font-medium text-gray-700 text-lg mb-4">plu.sh</h4>
            </a>
            <p className="font-normal text-gray-500 text-md">
              A free URL shortening service
            </p>
            <img
              src="/plush.png"
              alt="plu.sh URL shortener"
              className="flex justify-center items-center mt-4 m-auto cursor-pointer"
              style={{ maxHeight: 250 }}
              onClick={() => setLightboxIndex(5)}
            ></img>
          </div>
        </div>

        <div className="text-center md:mt-32 mt-16">
          <hr className="h-px my-8 w-7/12  border-0 bg-gray-400 mx-auto"></hr>
          <h1
            id="contact"
            className="mt-2 font-normal text-gray-900 text-2xl md:text-3xl leading-none mb-8"
          >
            Contact
          </h1>

          <Contact />
        </div>
      </div>
    </div>
  );
}

export default App;
